module.exports = __webpack_public_path__ + "static/media/1023785.fd6e4649.png";